import Head from "framework/ui/content/Head";
import NavBar from "framework/ui/content/NavBar";
import icon from "./images/icon.png";
import PageContent from "framework/ui/content/PageContent";
import Breadcrumbs from "framework/ui/content/Breadcrumbs";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import GuestBook from "framework/ui/guestbook/GuestBook";
import HtmlFile from "framework/ui/content/HtmlFile";
import Instagram from "framework/ui/embed/Instagram";
import Copyright from "framework/ui/content/Copyright";
import Page from "framework/ui/content/Page";
import React from "react";

import './css/NavBar.css'
import './css/GuestBook.css'
import './css/PageSections.css'

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <Head/>
      <NavBar icon={icon} brand={"Vanags.com"} expand="sm" theme={"dark"}/>
      <PageContent>
        <Breadcrumbs/>
        <PageTitle/>
        <PageSections/>
        <GuestBook pageId={6473} guestBookId={40}/>
        <HtmlFile pageId={6466} fileName={'files/resume.html'}/>
        <Instagram pageId={8704} url='https://www.instagram.com/marrowstoneeats'/>
        <Copyright startYear={1997} siteName={''}/>
      </PageContent>
    </Page>
  );
}